import ServiceTemplate from '../ServiceTemplate';

const FamilyFinance = () => {
  const serviceData = {
    title: 'ייעוץ לכלכלת המשפחה',
    description: 'תכנון פיננסי מקיף למשפחה, כולל ניהול תקציב, חיסכון והתייעלות כלכלית, עם דגש על בניית תכנית מותאמת אישית לצרכים והמטרות שלכם.',
    sections: [
      {
        title: 'למה צריך ייעוץ לכלכלת המשפחה?',
        content: 'ניהול כלכלת המשפחה הוא אתגר מורכב שדורש ידע, תכנון וראייה לטווח ארוך. ייעוץ מקצועי יכול לעזור לכם לנהל נכון את התקציב המשפחתי, לחסוך יותר, להתייעל בהוצאות ולהגיע ליציבות כלכלית. אנחנו נלווה אתכם בבניית תכנית פיננסית מותאמת אישית שתעזור לכם להשיג את המטרות הכלכליות שלכם.'
      },
      {
        title: 'מה כולל השירות?',
        content: 'השירות כולל ניתוח מקיף של המצב הפיננסי הנוכחי, בניית תקציב משפחתי מאוזן, זיהוי אפשרויות לחיסכון והתייעלות, תכנון חסכונות לטווח קצר וארוך, ייעוץ לגבי השקעות והלוואות, וליווי מתמשך ביישום התכנית. נעזור לכם לפתח הרגלים פיננסיים בריאים ולקבל החלטות כלכליות מושכלות.'
      }
    ],
    benefits: [
      'תכנית פיננסית מותאמת אישית',
      'ניהול תקציב יעיל ומאוזן',
      'הגדלת החיסכון המשפחתי',
      'התייעלות בהוצאות השוטפות',
      'תכנון חסכונות לטווח ארוך',
      'שיפור ההתנהלות הפיננסית'
    ],
    faqs: [
      {
        question: 'איך מתחילים את התהליך?',
        answer: 'התהליך מתחיל בפגישת ייעוץ ראשונית בה נכיר את המצב הפיננסי הנוכחי שלכם, נבין את המטרות והאתגרים, ונתחיל לבנות תכנית פעולה מותאמת. נבקש מכם להביא נתונים על ההכנסות וההוצאות כדי שנוכל לבצע ניתוח מדויק.'
      },
      {
        question: 'כמה זמן לוקח לראות תוצאות?',
        answer: 'התוצאות הראשונות יכולות להיות מורגשות כבר אחרי חודש-חודשיים של יישום התכנית, בעיקר בהתייעלות בהוצאות השוטפות. תוצאות משמעותיות יותר, כמו הגדלת החסכונות והשגת יעדים כלכליים, יתחילו להיראות אחרי 6-12 חודשים של עבודה מסודרת.'
      },
      {
        question: 'האם מתאים לכל משפחה?',
        answer: 'כן, השירות מתאים לכל משפחה, ללא קשר למצב הכלכלי הנוכחי. בין אם אתם מתמודדים עם חובות, רוצים להגדיל את החסכונות, או פשוט לנהל את הכספים בצורה טובה יותר - נתאים את התכנית למצב ולצרכים הספציפיים שלכם.'
      },
      {
        question: 'איך מתמודדים עם הוצאות לא צפויות?',
        answer: 'חלק חשוב מהתכנית הפיננסית הוא בניית קרן חירום למקרים לא צפויים. נלמד אתכם איך לבנות תקציב גמיש שכולל מרווח להוצאות לא מתוכננות, ואיך לנהל נכון מצבים של הוצאות חריגות מבלי לפגוע ביציבות הכלכלית.'
      },
      {
        question: 'האם מקבלים ליווי מתמשך?',
        answer: 'כן, אנחנו מציעים ליווי מתמשך שכולל פגישות מעקב תקופתיות, עדכון התכנית בהתאם לשינויים, ותמיכה שוטפת בהתמודדות עם אתגרים כלכליים. התדירות והאינטנסיביות של הליווי נקבעות בהתאם לצרכים שלכם.'
      }
    ],
    whatsappMessage: 'שלום, אני מתעניין/ת בייעוץ לכלכלת המשפחה ואשמח לקבל מידע נוסף.'
  };

  return <ServiceTemplate {...serviceData} />;
};

export default FamilyFinance; 